module.exports = __webpack_public_path__ + "assets/img/icon-mine-purple.44ae7581.png";